// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SortOption = t.struct({
    key: t.String,
    order: t.String,
    value: t.String
}, 'SortOption');

export default SortOption;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/state/sort-option.js